import { createSlice } from '@reduxjs/toolkit';
import { S3State } from '../../types/s3.types';
import { 
    fetchEnValidationFiles,
    fetchB2BValidationFiles,
    fetchB2BRenewalFiles,
    fetchCensusErrorFiles,
    fetchEmpyreanErrorFiles
} from '../actions/s3Actions';

const initialState: S3State = {
    enValidation: {
        files: [],
        currentPrefix: '',
        loading: false,
        error: null
    },
    b2bValidation: {
        files: [],
        currentPrefix: '',
        loading: false,
        error: null
    },
    b2bRenewal: {
        files: [],
        currentPrefix: '',
        loading: false,
        error: null
    },
    censusErrors: {
        files: [],
        currentPrefix: '',
        loading: false,
        error: null
    },
    empyreanErrors: {
        files: [],
        currentPrefix: '',
        loading: false,
        error: null
    }
};

const s3Slice = createSlice({
    name: 's3',
    initialState,
    reducers: {
        clearS3State: (state) => {
            state.enValidation = initialState.enValidation;
            state.b2bValidation = initialState.b2bValidation;
            state.b2bRenewal = initialState.b2bRenewal;
            state.censusErrors = initialState.censusErrors;
            state.empyreanErrors = initialState.empyreanErrors;
        }
    },
    extraReducers: (builder) => {
        // EN Validation Files
        builder
            .addCase(fetchEnValidationFiles.pending, (state) => {
                state.enValidation.loading = true;
                state.enValidation.error = null;
            })
            .addCase(fetchEnValidationFiles.fulfilled, (state, action) => {
                state.enValidation.loading = false;
                state.enValidation.files = action.payload.files;
                state.enValidation.currentPrefix = action.payload.current_prefix;
            })
            .addCase(fetchEnValidationFiles.rejected, (state, action) => {
                state.enValidation.loading = false;
                state.enValidation.error = action.error.message || 'Failed to fetch EN validation files';
            })
            
        // B2B Validation Files
        builder
            .addCase(fetchB2BValidationFiles.pending, (state) => {
                state.b2bValidation.loading = true;
                state.b2bValidation.error = null;
            })
            .addCase(fetchB2BValidationFiles.fulfilled, (state, action) => {
                state.b2bValidation.loading = false;
                state.b2bValidation.files = action.payload.files;
                state.b2bValidation.currentPrefix = action.payload.current_prefix;
            })
            .addCase(fetchB2BValidationFiles.rejected, (state, action) => {
                state.b2bValidation.loading = false;
                state.b2bValidation.error = action.error.message || 'Failed to fetch B2B validation files';
            })
            
        // B2B Renewal Files
        builder
            .addCase(fetchB2BRenewalFiles.pending, (state) => {
                state.b2bRenewal.loading = true;
                state.b2bRenewal.error = null;
            })
            .addCase(fetchB2BRenewalFiles.fulfilled, (state, action) => {
                state.b2bRenewal.loading = false;
                state.b2bRenewal.files = action.payload.files;
                state.b2bRenewal.currentPrefix = action.payload.current_prefix;
            })
            .addCase(fetchB2BRenewalFiles.rejected, (state, action) => {
                state.b2bRenewal.loading = false;
                state.b2bRenewal.error = action.error.message || 'Failed to fetch B2B renewal files';
            })
            
        // Census Error Files
        builder
            .addCase(fetchCensusErrorFiles.pending, (state) => {
                state.censusErrors.loading = true;
                state.censusErrors.error = null;
            })
            .addCase(fetchCensusErrorFiles.fulfilled, (state, action) => {
                state.censusErrors.loading = false;
                state.censusErrors.files = action.payload.files;
                state.censusErrors.currentPrefix = action.payload.current_prefix;
            })
            .addCase(fetchCensusErrorFiles.rejected, (state, action) => {
                state.censusErrors.loading = false;
                state.censusErrors.error = action.error.message || 'Failed to fetch Census error files';
            })
            
        // Empyrean Error Files
        builder
            .addCase(fetchEmpyreanErrorFiles.pending, (state) => {
                state.empyreanErrors.loading = true;
                state.empyreanErrors.error = null;
            })
            .addCase(fetchEmpyreanErrorFiles.fulfilled, (state, action) => {
                state.empyreanErrors.loading = false;
                state.empyreanErrors.files = action.payload.files;
                state.empyreanErrors.currentPrefix = action.payload.current_prefix;
            })
            .addCase(fetchEmpyreanErrorFiles.rejected, (state, action) => {
                state.empyreanErrors.loading = false;
                state.empyreanErrors.error = action.error.message || 'Failed to fetch Empyrean error files';
            });
    }
});

export const { clearS3State } = s3Slice.actions;
export default s3Slice.reducer; 